/** 生成客户端的配置：同源、带客户端标识、错误统一抛出 problem+json 里的中文说明。 */
import { client } from "./gen/client.gen";

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: Record<string, unknown>;

  constructor(status: number, code: string, message: string, details: Record<string, unknown> = {}) {
    super(message);
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

client.setConfig({ baseUrl: "", headers: { "x-zhaoxi-client": "web" }, throwOnError: true });

/** 未配对的设备：界面据此显示配对页（ADR-0012）。 */
export const pairing = { listeners: new Set<() => void>(), unpaired: false };

client.interceptors.error.use(
  (error: unknown, response: Response | undefined, request: Request | undefined) => {
    const body = (error ?? {}) as {
      detail?: string;
      title?: string;
      code?: string;
      details?: Record<string, unknown>;
    };
    const message = typeof body.detail === "string" ? body.detail : (body.title ?? "请求失败");
    const code = body.code ?? "error";
    if (code === "device_unpaired" && !pairing.unpaired) {
      pairing.unpaired = true;
      for (const fn of pairing.listeners) fn();
    }
    // 接口失败传回 Mac（上报接口自己失败不再上报）
    if (request && (response?.status ?? 0) >= 500 && !request.url.includes("/client-logs")) {
      const where = `${request.method} ${new URL(request.url, location.href).pathname}`;
      void import("@/shared/telemetry").then((t) =>
        t.report("api", `${where} → ${response?.status}：${message}`),
      );
    }
    return new ApiError(response?.status ?? 0, code, message, body.details ?? {});
  },
);

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return "出了点问题";
}

export { client };
